<template>
  <div class="flex flex-col w-full max-h-[70vh] overflow-y-auto px-2 pb-4">
    <button
      v-for="opt in options"
      :key="String(opt.value)"
      type="button"
      class="flex items-center justify-between gap-2 px-3 py-3 rounded-lg text-sm text-right transition-colors"
      :class="opt.value === selected ? 'bg-primary-50 text-primary font-semibold' : 'text-gray-700 hover:bg-gray-50'"
      @click="onSelect(opt.value)"
    >
      <span>{{ opt.label }}</span>
      <i v-if="opt.value === selected" class="pi pi-check text-primary text-sm" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { type PropType } from 'vue';
import type { SkinConcernEnum } from '@torim-app/types';

type Metric = 'overall' | SkinConcernEnum;

defineProps({
  options: {
    type: Array as PropType<Array<{ value: Metric; label: string }>>,
    required: true,
  },
  selected: {
    type: String as PropType<Metric>,
    required: true,
  },
});

const emit = defineEmits<{ (e: 'select', value: Metric): void }>();

const onSelect = (value: Metric) => emit('select', value);
</script>
